import Component from '../../js/_Component';
import CategoryFilter from '../../js/util/_CategoryFilter';

export default class PageTv extends Component {
	/** The component's base class. */
	private baseClass = 'c-video-player-with-list';

	/** The select element which filters the videos by category. */
	private select: HTMLSelectElement;

	/** The videos in the grid. */
	private videos: NodeListOf<HTMLDivElement>;

	constructor(element: HTMLElement) {
		super(element);

		this.select = element.querySelector('.c-filter-select > select');
		this.videos = element.querySelectorAll(`.${this.baseClass}__thumb`);

		new CategoryFilter(this.select, this.videos);
	}
}

Component.register(PageTv, 'PageTv');
